import type { EditoProductPushModel, FlexibleSectionModel, ProductsGroupModel } from '~/diptyqueTheme/types/contentful';
export const adaptEditoProductPush = (data: FlexibleSectionModel): EditoProductPushModel => {
  const items = data.itemsCollection?.items || [];

  const getItemSku = (
    item: ProductsGroupModel & {
      sku?: string | string[];
    }
  ): string => {
    if (item.sku && Array.isArray(item.sku)) {
      return item.sku[0];
    }

    return item.sku as string;
  };

  return {
    ...data,
    etitle: data.eTitle,
    visualEntry: data.visual,
    sku: items[0] ? getItemSku(items[0]) : ''
  };
};
